import { useEffect, useRef, useState } from "react";

export default function AnimLoader({size, color, lineWidth}: {
    size: number;
    color?: string;
    lineWidth?: number;
}) {

    const ref = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (!ref.current) return;
        const canvas = ref.current;
        const ctx = canvas.getContext("2d")!;
        let time = 0;
        let angle = 0;
        const lw = lineWidth ?? 4;
        const col = color ?? "white";
        const deltaTime = 1/24;
        const tick = () => {
            time += deltaTime;
            angle += 2*Math.PI*deltaTime;
            if (angle >= 2*Math.PI) angle -= 2*Math.PI;

            ctx.strokeStyle = col;
            ctx.lineWidth = lw;

            const start = angle;
            const end = start + ((Math.sin(time*Math.PI)*0.5 + 0.5) * 2*Math.PI);
            // const end = start + Math.PI/4

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            ctx.beginPath();
            ctx.arc(canvas.width/2, canvas.height/2, size/2 - lw/2, start, end);
            ctx.stroke();
            ctx.closePath();
        };

        const t = setInterval(tick, 1000/24);

        return () => {
            clearInterval(t);
        }
    }, [ref.current]);

    return (
        <canvas ref={ref} width={size} height={size}></canvas>
    );
}